import { Button } from '@atoms';
interface IButtonEnforceProps {
  onClick: () => void;
  disabled?: boolean;
}

const EnforceButton = ({ onClick, disabled }: IButtonEnforceProps) => {
  return (
    <Button
      variant="contained"
      color="black"
      onClick={onClick}
      disabled={disabled}
      sx={{
        paddingX: '30px',
        color: '#fff',
        backgroundColor: '#FF4848',
        '&:hover': {
          backgroundColor: '#b23232',
        },
        '&:disabled': {
          border: 'initial',
        },
      }}
    >
      Enforce
    </Button>
  );
};
export default EnforceButton;
